var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-link',{staticClass:"btn-social apple-btn",class:{ onlyIcon: _vm.onlyIcon },on:{"click":_vm.signInWithApple}},[_c('b-img',{class:{ onlyIcon: _vm.onlyIcon },attrs:{"src":_vm.getImage,"alt":_vm.$t('continueWithApple')}}),(!_vm.onlyIcon)?[_vm._v(" "+_vm._s(_vm.$t("continueWithApple"))+" ")]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }